import MkuPagination from './src/pagination';

MkuPagination.install = function (Vue) {
  Vue.component(MkuPagination.name, MkuPagination);
};

export default MkuPagination;
